import React, { useEffect, useState } from 'react';
import { useMatch, useOutletContext } from 'react-router-dom';
// @ts-ignore
import permissions from 'invitemember-permissions-model';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import { OutletContext } from '@/types';
import { useFetch } from '@/hooks/useFetch';
import { LoadingScreen } from '@/components/LoadingScreen';
import LoaderIcon from '@/images/icons/Loader';
import { fetchAPI } from '@/api';
import BackButtonPage from '@/components/BackButtonPage';
import MemberPermissionsList from '@/components/MemberPermissionsList/MemberPermissionsList';

function MemberPermissions() {
  const { project, auth } = useOutletContext<OutletContext>();
  const match = useMatch('/member/permissions/:userId');
  const { data, isLoading, callFetch }: any = useFetch('/project/team/member', {
    projectId: project.projectId,
    userId: match?.params.userId,
  });

  const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);

  useEffect(() => {
    callFetch();
  }, [match]);

  const onPermissionsSave = async () => {
    if (!isSaveLoading) {
      setIsSaveLoading(true);

      try {
        const response = await fetchAPI('/project/team/member/update', auth.user.token, {
          projectId: project.projectId,
          userId: match?.params.userId,
          permissions: [...new Set(selectedPermissions)],
        });

        if (!response.ok) {
          throw new Error(`This is an HTTP error: The status is ${response.status}`);
        }
        let actualData = await response.json();

        setSaveError(null);
      } catch (error: any) {
        let errorMessage = 'An unexpected error occurred';
        if (error.response?.message) {
          errorMessage = error.response.message;
        }
        setSaveError(errorMessage);
      } finally {
        setIsSaveLoading(false);
      }
    }
  };

  if (isLoading || !data) {
    return <LoadingScreen />;
  }

  const userName = data.user.firstName + (data.user.lastName ? ' ' + data.user.lastName : '');

  return (
    <StaticLayoutInner>
      <div className="relative">
        <BackButtonPage to={`/settings/edit-project/team`} title="Team" backgroundColor="#EAE6E0" />
        <div className="flex flex-col w-full sm:grid grid-cols-[2fr_1fr] mb-8 sm:mb-12 relative">
          <h1 className="h1 col-start-1 col-end-2 mb-4">Edit permissions for {userName}</h1>
          <div className="text-[#A5A5A5] col-start-1 col-end-2">
            Here you can choose which permissions to grant access for the member.
          </div>
          <div className="flex justify-end mt-8 sm:mt-0 col-start-2 row-start-1">
            <button
              className="btn-primary min-w-[60px] sm:h-8 h-10 py-1.5 px-3"
              onClick={() => onPermissionsSave()}
            >
              {isSaveLoading ? (
                <div className="flex items-center justify-center py-1 pointer-events-none">
                  <LoaderIcon className="animate-rotation w-5 h-5 text-white" />
                </div>
              ) : (
                `Save`
              )}
            </button>
          </div>
        </div>
      </div>
      {saveError && (
        <div className="text-sm text-red-orange mb-6 font-medium">{saveError}</div>
      )}
      <MemberPermissionsList
        data={data}
        selectedPermissions={selectedPermissions}
        onChangePermissions={(selected: string[]) => setSelectedPermissions(selected)}
      />
    </StaticLayoutInner>
  );
}

export default MemberPermissions;
